
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1604125679952",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "1947",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M925.23990594 23.62695312H624.69589598c-41.4888165 0-75.13314093 33.6366936-75.13314093 75.13314094v150.26818956c0 41.49644732 33.64432443 75.14077176 75.13314093 75.14077177H925.23799823c41.49644732 0 75.13314093-33.64432443 75.13314094-75.14077177V98.76009406C1000.37304688 57.26364673 966.73635327 23.62695312 925.23990594 23.62695312zM399.29647319 23.62695312H98.76009406C57.27127756 23.62695312 23.62695312 57.26364673 23.62695312 98.76009406v450.79503016c0 41.50407816 33.64432443 75.14840258 75.13314094 75.14840259h300.53447142c41.50407816 0 75.13314093-33.64432443 75.13314093-75.14840259V98.76009406C474.42961412 57.26364673 440.79864364 23.62695312 399.29647319 23.62695312z m525.94343275 375.66952007H624.69589598c-41.4888165 0-75.13314093 33.62906277-75.13314093 75.12551011v450.81029182c0 41.49644732 33.64432443 75.14077176 75.13314093 75.14077176H925.23799823c41.49835503 0 75.13504864-33.64432443 75.13504864-75.14077176v-450.81029182c0-41.49644732-33.6366936-75.12551011-75.13314093-75.12551011zM399.29647319 699.83094461H98.76009406C57.27127756 699.83094461 23.62695312 733.46763822 23.62695312 774.96408555v150.26818957C23.62695312 966.72872244 57.27127756 1000.37304688 98.76009406 1000.37304688h300.53447142c41.50407816 0 75.13314093-33.64432443 75.13314093-75.14077176V774.96408555c0.00190771-41.49644732-33.62906277-75.13314093-75.13123322-75.13314094z",
        "p-id": "1948"
      }
    }
  ]
})
    }
  